import type { ReactNode } from 'react';
import { adminLogout } from '../lib/api';
import { siteIdentity } from '../content/siteContent';
import type { AdminSession } from '../lib/types';

export function AdminLayout({ session, children, onSignedOut }: { session: AdminSession; children: ReactNode; onSignedOut: () => void }) {
  async function signOut() {
    await adminLogout(session.csrfToken);
    onSignedOut();
  }

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <a className="admin-brand" href="/admin">Casa <span>Borinquen</span></a>
        <nav aria-label="Admin navigation">
          <a href="/admin">Dashboard</a>
          <a href="/admin/inquiries">Inquiries</a>
          <a href="/admin/pages">Pages</a>
          <a href="/admin/posts">Posts</a>
          <a href="/admin/catalog">{siteIdentity.catalogLabel}</a>
          <a href="/admin/media">Media</a>
        </nav>
        <div className="admin-sidebar__user"><span>{session.user.displayName}</span><button type="button" onClick={signOut}>Sign out</button></div>
      </aside>
      <main className="admin-main">{children}</main>
    </div>
  );
}
